import Vue from 'vue';
import moment from 'moment'
import truncateFilter from '../../utils/truncateFilter';

export default Vue.component('bid-history', {
  props: ['monetization', 'currency', 'accountId'],

  data() {
    return {}
  },
  created() {

  },
  computed: {
  },
  methods: {
    getDate(log) {
      return moment(log.date).format('DD.MM.YYYY HH:mm:ss.SS')
    },
    getWho(log) {
      if (typeof log.who === 'string') {
        return log.who === 'robot' ? 'Licitátor' : log.who
      } else {
        return log.who.contact.code
      }
    },
    getType(log) {
      return log.text.includes('online-auction') ? 'dražby' : 'aukce'
    },
    getParticipant(log) {
      if (log.text.includes('@')) {
        const participantCodes = log.text.split('@')
        participantCodes.shift()
        return participantCodes.length === 2 ? participantCodes.join(' a ') : participantCodes.join(', ')
      }
      return ''
    },
    getParticipantText(log) {
      if (log.text.includes('@')) {
        const participantCodes = log.text.split('@')
        participantCodes.shift()
        return participantCodes.length > 1 ? 'účastníky' : 'účastníkem'
      }
      return ''
    },
    getParticipantTextBid(log) {
      if (log.text.includes('@')) {
        const participantCodes = log.text.split('@')
        participantCodes.shift()
        return participantCodes.length > 1 ? 'udělím jim příklep' : 'udělím mu příklep'
      }
      return ''
    },
    getParticipantLotText(log) {
      if (log.text.includes('@')) {
        const participantCodes = log.text.split('@')
        participantCodes.shift()
        return participantCodes.length > 1 ? 'Probíhá losování z přihlášených účastníků s předkupním právem.' : ''
      }
      return ''
    },
    getLogText(log) {
      let htmlText = log.htmlText
      if (htmlText) {
        if (log.who?.contact?.id === this.accountId) {
          htmlText = htmlText.replace(`<strong>${log.who.contact.code}</strong>`, `<strong>${log.who.contact.code}</strong> <div class="icon text-primary" style="position: relative; top: -2px;"><svg aria-hidden="true" data-prefix="fas" data-icon="user" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-user fa-w-14 fa-3x"><path fill="currentColor" d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"></path></svg></div>`)
        }
        return htmlText
      }
      return ''
    },
    truncateLog(text) {
      return truncateFilter(text, 500, true)
    },
    logCollapse(log, val) {
      log['collapsed'] = val
      this.$forceUpdate()
    },
    slice(val, countChars) {
      return val ? val.slice(countChars) : val
    }
  }
});
